import { forwardRef } from "react";
import classNames from "classnames";
import TextArea from "antd/lib/input/TextArea";
import type { TextAreaProps } from "antd/lib/input";
import styles from "./styles.module.scss";

type Props = TextAreaProps;

export const AppTextArea = forwardRef<HTMLTextAreaElement, Props>(
  ({ className, ...props }, ref) => {
    return (
      <TextArea
        ref={ref}
        size="large"
        className={classNames(styles.textarea, className)}
        {...props}
      />
    );
  },
);
